import { useEffect, useState } from "react";
import { db, doc, onSnapshot } from "./firebase";
import { awardXp as awardXpCallable } from "./functions";
import { audit } from "./audit";

export async function awardXp({ event, payload }) {
  if (!event) throw new Error("event required");
  try {
    const res = await awardXpCallable({ event, payload: payload || null });
    const result = res || { awarded: 0 };
    if (typeof window !== "undefined" && result.awarded > 0) {
      window.dispatchEvent(
        new CustomEvent("gami:awarded", {
          detail: {
            event,
            awarded: result.awarded,
            newBadges: result.newBadges || [],
          },
        }),
      );
    }
    return result;
  } catch (e) {
    // Gamification must never block UX.
    // eslint-disable-next-line no-console
    console.warn("[gamification] awardXp failed", e && e.message);
    return { awarded: 0, error: e && e.message };
  }
}

export function useUserProgress(uid) {
  const [state, setState] = useState({ loading: true, data: null });
  useEffect(() => {
    if (!db || !uid) { setState({ loading: false, data: null }); return; }
    const unsub = onSnapshot(doc(db, "user_progress", uid), (snap) => {
      setState({ loading: false, data: snap.exists() ? snap.data() : null });
    }, (err) => {
      // eslint-disable-next-line no-console
      console.warn("[gamification] progress snapshot err", err && err.message);
      setState({ loading: false, data: null });
    });
    return () => unsub();
  }, [uid]);
  return state;
}

export function useXp(uid) {
  const { data } = useUserProgress(uid);
  return { xp: (data && data.xp) || 0, level: (data && data.level) || 0 };
}

export function useStreak(uid) {
  const { data } = useUserProgress(uid);
  return {
    days: (data && data.streakDays) || 0,
    lastDay: (data && data.streakLastDay) || null,
  };
}

export async function logGamificationEvent(uid, event, payload) {
  await audit({
    action: `gamification.${event}`,
    actor: { uid },
    targetCollection: "user_progress",
    targetId: uid || null,
    metadata: { event, ...(payload || {}) },
  });
}
